// ✉️ The show-email box's rules (ExplorerTheaterPage), pure so jest can pin
// them. 09-24 "Update" fix: changing the address used to leave the OLD one
// subscribed. The server now returns a NEW address's change-address code
// (never its unsubscribe token, which only travels in emails), and an update
// sends the old address + that code so the server can drop it (explorer
// handler.js email_subscribe; gate tools/smoke-email-update.js).

export const EMAIL_KEY = 'chibi_email_notify';
export const TOKEN_KEY = 'chibi_email_notify_token';

const same = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();

// The POST body for `email`, given what this browser remembers.
export function subscribeRequest(email, prevEmail, prevToken) {
  const changing = !!prevEmail && !same(prevEmail, email);
  const replaces = changing && prevToken ? { replaces: { email: prevEmail, token: prevToken } } : {};
  return { changing, body: { email_subscribe: { email, ...replaces } } };
}

// Remember the result. A token only ever sits beside the address it belongs
// to. Returns true when the old address is still on the list (the server
// couldn't drop it), so the box can say so.
export function rememberSubscribe(storage, email, changing, response) {
  storage.setItem(EMAIL_KEY, email);
  if (response && response.token) storage.setItem(TOKEN_KEY, response.token);
  else if (changing) storage.removeItem(TOKEN_KEY);
  return changing && !(response && response.replaced);
}
